// Stable, searchable identifiers for feature gates. These are not secrets and
// do not represent stored membership state.
export const VIP_GATE_KEYS = {
  messaging: 'vip_gate.messaging',
  privatePhotos: 'vip_gate.private_photos',
  advancedFilters: 'vip_gate.advanced_filters'
} as const

export type VipGateKey = (typeof VIP_GATE_KEYS)[keyof typeof VIP_GATE_KEYS]
